import { useParams } from 'react-router-dom'

export const useEventIdParam = () => {
  const { eventId } = useParams()

  if (!eventId) throw new Error('Must be used on a route with an eventId param')
  return { eventId }
}
